import { useState } from 'react';
import { siteMeta } from '@/mocks/home';

export default function SubscribeBlock() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleClick = () => {
    if (!email.trim() || !email.includes('@')) {
      setMessage('请输入有效的邮箱地址');
      return;
    }
    setMessage('已记录，本期速览将在每周四准时送达');
    setEmail('');
  };

  return (
    <section id="subscribe" className="w-full bg-primary-500 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto flex max-w-[1280px] flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-background-50/70" />
            <span className="font-label text-[11px] uppercase tracking-[0.32em] text-background-50/80">
              Weekly Digest / 订阅速览
            </span>
          </div>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
            每周四，把这一周的反差整理成一封速览
          </h2>
          <p className="mt-4 text-sm leading-loose text-background-50/90 md:text-base">
            封面人物、快讯时间线与热度榜变化，一次读完。不追热点，只做归档。
          </p>
        </div>

        <div className="w-full max-w-md">
          <div className="flex flex-col gap-3 sm:flex-row">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              aria-label="订阅邮箱"
              className="w-full rounded-md border border-background-50/40 bg-background-50/10 px-4 py-3 font-label text-sm text-background-50 placeholder:text-background-50/60 focus:border-background-50 focus:outline-none"
            />
            <button
              type="button"
              onClick={handleClick}
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 font-label text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-send-plane-line" />
              订阅
            </button>
          </div>
          <p className="mt-3 min-h-[18px] font-label text-xs text-background-50/90" role="status">
            {message}
          </p>
          <p className="mt-1 font-label text-[11px] text-background-50/70">
            {siteMeta.issue} · 本页为静态展示，内容仅作示例
          </p>
        </div>
      </div>
    </section>
  );
}